
import { UserService } from "../../shared/services/user/user.service";
import { User } from '../../model/user/user.model';
import { IValidationMessages, ApiResult } from '../../model/common/error/error.model'; 
import { Constant } from '../../model/common/constant';
import { MessageService } from "../../shared/services/common/message.service";
import { WindowService, IWindowOption } from "../../shared/services/common/window/window.service";


let template = require('./forgotlogin.html');

export enum ForgotLoginPageState {
    ForgotLogin = 1,
    VerifySecurityQuestion = 2,
    ResetPassword = 3,
    ResetPasswordMailSent = 4,
    UsernameMailSent = 5
}

export enum RadioButtonState {
    Question = 1,
    Link = 2,
    Username = 3
}

export class ForgotLoginComponentController implements ng.IComponentController {
    public user: User;
    public userdatajson: string;

    public forgotLoginForm: ng.IFormController;
    public userService: UserService;
    public windowService: WindowService;
    public msgService: MessageService;


    public userNameorEmail: string;
    public emailId: string;
    public emailPattern: RegExp = Constant.EmailPattern;
    public pageState: ForgotLoginPageState;
    public selectedRadioButton: number = 0;
    public forgotLoginChoices: Array<String>;
    public forgotLoginChoice: String;
    public notifyUser: boolean;
    public $translate: ng.translate.ITranslateService;

    public static $inject: Array<string> = ["UserService", "WindowService", "MessageService", "$translate"];
    constructor(userService: UserService, windowService: WindowService, messageService: MessageService, $translate: ng.translate.ITranslateService, forgotLoginChoices: Array<String>) {
        this.userService = userService;
        this.windowService = windowService;
        this.msgService = messageService;
        this.$translate = $translate;
    }
    $onInit() {
        this.pageState = ForgotLoginPageState.ForgotLogin;
    }

    continue() {
        if (this.forgotLoginForm.$valid) {
            this.forgotLoginChoices = [this.$translate.instant("TEXT.RESETPASSWORD"), this.$translate.instant("TEXT.RETRIEVEUSERNAME")];
            if (this.forgotLoginChoice == this.forgotLoginChoices[0]) {
                this.notifyUser = this.selectedRadioButton == RadioButtonState.Link;

                this.userService.forgotPassword(this.userNameorEmail, this.notifyUser).then((res: ng.IHttpPromiseCallbackArg<ApiResult<User>>) => {
                    if (res && res.data.Status) {
                        this.user = new User(res.data.Data);
                        if (this.notifyUser) {
                            this.pageState = ForgotLoginPageState.ResetPasswordMailSent;
                        } else {
                            if (this.user.SelectedSecretQuestions.length > 0) {
                                this.pageState = ForgotLoginPageState.VerifySecurityQuestion;
                            } else {
                                this.showMessageIfSecretQuestionNotSet();
                            }
                        }
                    }
                    else {
                        let validationMsg: Array<IValidationMessages> = [];
                        res.data.ValidationResults.forEach(t =>
                            validationMsg.push({ Key: t.ErrorCode, Message: t.ErrorMessage } as IValidationMessages));
                        this.windowService.showErrorWindow({
                            TextContentList: this.msgService.getLocalisedMessageList(validationMsg)
                        } as IWindowOption);
                    }
                });
            }
            else {
                this.userService.forgotUsername(this.emailId).then((res: ng.IHttpPromiseCallbackArg<ApiResult<User>>) => {
                    if (res && res.data.Status) {
                        this.user = new User(res.data.Data);
                        this.pageState = ForgotLoginPageState.UsernameMailSent;
                    }
                    else {
                        let validationMsg: Array<IValidationMessages> = [];
                        res.data.ValidationResults.forEach(t =>
                            validationMsg.push({ Key: t.ErrorCode, Message: t.ErrorMessage }));
                        this.windowService.showErrorWindow({
                            TextContentList: this.msgService.getLocalisedMessageList(validationMsg)
                        } as IWindowOption);
                    }
                });
            }
        }
    }


    showMessageIfSecretQuestionNotSet() {
        this.windowService.showErrorWindow({
            TextContent: this.$translate.instant("TEXT.SECRETQUESTIONNOTAVAILABLE")
        } as IWindowOption);
    }


    back() {
        //window.location.href = Path.Provider.ApplicationPath;
        window.history.back();
    }

    disableContinueButton(): boolean {
        this.forgotLoginChoices = [this.$translate.instant("TEXT.RESETPASSWORD"), this.$translate.instant("TEXT.RETRIEVEUSERNAME")];
        return !(this.forgotLoginChoice == this.forgotLoginChoices[1] && !this.forgotLoginForm.$invalid) && !((this.selectedRadioButton == 1 || this.selectedRadioButton == 2) && !this.forgotLoginForm.$invalid)
    }
}

export let forgotLoginComponent: ng.IComponentOptions = {
    template: template.default,
    transclude: false,
    controllerAs: Constant.CtrlAs,
    controller: ForgotLoginComponentController,
};

